import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

export default function OIDCCallback() {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    const handleAuth = async () => {
      if (auth.isAuthenticated && auth.user?.access_token) {
        try {
          const returnUrl = sessionStorage.getItem("returnUrl") || "/";
          sessionStorage.removeItem("returnUrl");
          navigate(returnUrl, { replace: true });
        } catch (e) {
          console.error("Backend login failed:", e);
          // Don't immediately redirect on API failure - give a moment for retry
          setTimeout(() => {
            navigate("/login", { replace: true });
          }, 2000);
        }
      } else if (auth.error) {
        console.error("OIDC callback error:", auth.error);
        navigate("/login", { replace: true });
      } else if (!auth.isLoading && !auth.isAuthenticated) {
        // Not authenticated and not loading - redirect to login
        navigate("/login", { replace: true });
      }
    };

    // Add a small delay to prevent race conditions
    const timeoutId = setTimeout(handleAuth, 100);
    return () => clearTimeout(timeoutId);
  }, [
    auth.isAuthenticated,
    auth.error,
    auth.isLoading,
    auth.user?.access_token,
    navigate,
  ]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted">Completing authentication...</p>
      </div>
    </div>
  );
}
